
 <template>
 <div>
  <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">
 <div class="p-6">
	 <h4 class="mt-8">General Infomation</h4>
        <!-- NAME -->
        <vs-input id="add-product-step-1" ref="name" label="Name" v-model="name" class="mt-5 w-full" name="name" v-validate="{required: true}" data-vv-validate-on="blur" />
        <span class="text-danger text-sm" v-show="errors.has('name')">{{ errors.first('name') }}</span>

         <!-- Description -->
        <div class="mt-5">
          <label class="vs-input--label">Product Description</label>
          <vs-textarea name="description" ref="description" v-model="description" counter="255" v-validate="{required: true}" :counter-danger.sync="counterDanger" data-vv-validate-on="blur" />
          <span class="text-danger text-sm" v-show="errors.has('description')">{{ errors.first('description') }}</span>
        </div>

        <!-- CATEGORY -->
				<label class="vs-input--label">Product Category</label>
				<v-select label="name" ref="category" v-model="category" class="w-full primary" name="category" :options="getCategory" v-validate="{required: true}" :dir="$vs.rtl ? 'rtl' : 'ltr'" data-vv-validate-on="blur">
				</v-select>
        <span class="text-danger text-sm" v-show="errors.has('category')">{{ errors.first('category') }}</span>


        <!-- PRODUCT CONDITION -->
        <div class="w-full mt-5 vx-row justify-between">
         <div class="vx-col">
          <label class="vs-input--label">Product Condition</label>
          <vx-tooltip text="This is to indicates the item's condition.">
            <vs-switch v-model="condition" style="width: 60px;">
              <span slot="on">New</span>
              <span slot="off">Used</span>
            </vs-switch>
          </vx-tooltip>
        </div>
        </div>
			
				<h4 class="mt-8">Product Variant Infomation</h4>
        <!-- VARIANT -->
        <div class="w-full mt-5 vx-row">
					<div class="vx-col">
          <label class="vs-input--label">Product Variant</label>
          <vx-tooltip text="This product contained more than 1 option.">
          <vs-switch @change="initOptions" v-model="variant" icon-pack="feather" vs-icon-off="icon-x" vs-icon-on="icon-check" vs-value=true style="width: 60px;">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
          </vs-switch>
          </vx-tooltip>
          </div>
        </div>

				<!-- Variant One  -->
				<div v-if="variant === true" class="variant-container">
					<div v-show="!isEnableRoot" class="p-3 mt-3 text-center align-center font-medium rounded cursor-pointer items-center text-base text-primary border border-solid border-primary" @click="isEnableRoot = true">
							<feather-icon icon="PlusCircleIcon" svgClasses="h-4 w-4" />
							<span class="ml-2 mt-1 text-base text-primary">Enable Variation 1</span>
					</div>
					<feather-icon v-show="isEnableRoot" icon="XIcon" @click="initEnable('root')" class="cross-icon cursor-pointer"></feather-icon>
					 
					<div v-show="isEnableRoot">
						<h5 class="mb-3">Variation 1</h5>
							<label class="vs-input--label">Option Name</label>
							<vs-input class="mb-5" ref="others" vid="others" v-model="others" name="others" placeholder="Color" v-validate="{ required: true }" data-vv-validate-on="blur" />
							<span class="text-danger text-sm" v-show="errors.has('others')">{{ errors.first('others') }}</span>

							<div>
								<label class="vs-input--label">Option Value</label>
							</div>
							<div class="form-group vx-row" v-for="(option, index) in variation.root" :key="index">
								<vs-input
								vid="option" 
								class="vx-col" 
								v-model="option.label" 
								placeholder="eg: Red" 
								v-validate="{required: true,is_not: option}" 
								:name="'variant 1 option '+(index+1)" 
								data-vv-validate-on="blur"
								ref="option"/> 
								<feather-icon class="cursor-pointer vx-col" icon="Trash2Icon" svgClasses="h-4 w-4" @click="removeRoot(index)"/>
								<span class="text-danger text-sm mt-3">{{ errors.first(`${'variant 1 option '+(index+1)}`) }}</span>
							</div>
							<div class="p-3 mt-3 w-3/4 text-center font-medium rounded cursor-pointer items-center text-base text-primary border border-solid border-primary" @click="addRootVariant" >
								<feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
								<span class="ml-2 text-base text-primary">Add {{others == '' ? 'Option' : others}}</span>
							</div>
					</div>
				</div>


				<!-- Variant Two  -->
				<div v-if="variant === true && variation.root.length > 0" class="variant-container">
					<div v-show="!isEnableTree" class="p-3 mt-3 text-center align-center font-medium rounded cursor-pointer items-center text-base text-primary border border-solid border-primary" @click="isEnableTree = true">
							<feather-icon icon="PlusCircleIcon" svgClasses="h-4 w-4" />
							<span class="ml-2 mt-1 text-base text-primary">Enable Variation 2</span>
					</div>
					<feather-icon v-show="isEnableTree" icon="XIcon" @click="initEnable('tree')" class="cross-icon cursor-pointer"></feather-icon>
					<div v-show="isEnableTree">
						<h5>Variation 2</h5>
							<label class="vs-input--label">Option Name</label>
							<vs-input class="mb-5" ref="others2" v-model="others2" placeholder="Size" name="others2" data-vv-validate-on="blur" v-validate="{required_if:'isEnableTree,true',is_not: others}" />
							<span class="text-danger text-sm" v-show="errors.has('others2')">{{ errors.first('others2') }}</span>

							<div>
								<label class="vs-input--label">Option Value</label>
							</div>
							<div class="form-group vx-row" v-for="(option, index) in variation.tree" :key="index">
								<vs-input 
								class="vx-col" 
								v-model="option.label" 
								placeholder="eg: S" 
								v-validate="'min:1'" 
								:name="'variant 2 option '+(index+1)" 
								data-vv-validate-on="blur"
								ref="option2"/> 
								<feather-icon class="cursor-pointer vx-col" icon="Trash2Icon" svgClasses="h-4 w-4" @click="removeTree(index)"/>
								<span class="text-danger text-sm mt-3">{{ errors.first(`${'variant 2 option '+(index+1)}`) }}</span>
							</div>
							<div class="p-3 mt-3 w-3/4 text-center font-medium rounded cursor-pointer items-center text-base text-primary border border-solid border-primary" @click="addTreeVariant">
								<feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
								<span class="ml-2 text-base text-primary">Add {{others2 == '' ? 'Option' : others2}}</span>
							</div>
					</div>
				</div>
				
				<!-- Apply All -->
				<div v-show="isEnableRoot || isEnableTree" class="apply-all-container">
					<div class="apply-all-info">
					<feather-icon class="mr-2" icon="InfoIcon" svgClasses="h-5 w-5"/>
					<span class="mb-2">Tips: You may directly apply all the values to variation summary table by key in them under these five text fields.</span>
					</div>
					
					<div class="apply-all-form">
						<vs-input class="price-input data-input-table sm:w-full xl:w-1/4" @focus="hoverPrice = true" @blur="hoverPrice = false" v-model="allPrice" name="allPrice" data-vv-validate-on="blur" label-placeholder="Price" v-validate="{regex : '^[+]?([0-9]+([.][0-9]*)?|[.][0-9]+)$'}" />
						<vs-input class="stock-input data-input-table sm:w-full xl:w-1/4" @focus="hoverStock = true" @blur="hoverStock = false" v-model="allStock" name="allStock" data-vv-validate-on="blur" label-placeholder="Stock" v-validate="{regex : '^[0-9]*$'}"/>
						<vs-input class="sku-input data-input-table sm:w-full xl:w-1/4" @focus="hoverSku = true" @blur="hoverSku = false" v-model="allSku" name="allSku" label-placeholder="SKU" />
						<vs-input class="volume-input data-input-table sm:w-full xl:w-1/4" @focus="hoverVolumetric = true" @blur="hoverVolumetric = false" @click="popupActive_all = true" v-model="allVolumetric" name="allVolumetric" label-placeholder="Volumetric" data-vv-validate-on="blur" v-validate="{regex : '^[+]?([0-9]+([.][0-9]*)?|[.][0-9]+)$'}"/>
						<vs-input class="weight-inpiut data-input-table sm:w-full xl:w-1/4" @focus="hoverWeight = true" @blur="hoverWeight = false" v-model="allWeight" name="allWeight" data-vv-validate-on="blur" label-placeholder="Weight" v-validate="{regex : '^[+]?([0-9]+([.][0-9]*)?|[.][0-9]+)$'}"/>

						<vs-popup classContent="popup-example" title="Volumetric Calculator" :active.sync="popupActive_all">
							<div class="volumetric-container">
								<div class="volumetric-cal-form">
										<div>
											<label class="vs-input--label">Length (cm)</label>
											<vs-input 
												class="length-text-field vx-col" 
												v-model="length" 
												v-validate="{required: true, regex : '^[+]?([0-9]+([.][0-9]*)?|[.][0-9]+)$'}" 
												name="length" 
												data-vv-validate-on="blur" />
											<span class="text-danger text-sm vx-col">{{ errors.first('length') }}</span>
										</div>
										
										
										<div>
											<label class="vs-input--label">Height (cm)</label>
											<vs-input 
												class="height-text-field vx-col" 
												v-model="height" 
												v-validate="{required: true, regex : '^[+]?([0-9]+([.][0-9]*)?|[.][0-9]+)$'}" 
												name="height" 
												data-vv-validate-on="blur" />
											<span class="text-danger text-sm vx-col">{{ errors.first('height') }}</span>
										</div>

										<div>
											<label class="vs-input--label">Width (cm)</label>
											<vs-input 
												class="width-text-field vx-col" 
												v-model="width" 
												v-validate="{required: true, regex : '^[+]?([0-9]+([.][0-9]*)?|[.][0-9]+)$'}" 
												name="width" 
												data-vv-validate-on="blur"/>
											<span class="text-danger text-sm">{{ errors.first('width') }}</span>
										</div>

										<vs-button class="sm:w-full xl:w-1/2 shadow-md mt-2" :disabled="!validateVolumetricForm" @click="calculateVolumetric(length,height,width,'a')">Calculate</vs-button>
									</div>

									<div class="volumetric-img">
										<img src="@/assets/images/pages/xmas_surprise.svg" />
										<div class="h"><span>H</span></div>
										<div class="w">W</div>
										<div class="l">L</div>
									</div>
							</div>		
							</vs-popup>
					</div>
					<div class="apply-all-button p-3 w-1/3 mr-3 text-center font-medium rounded cursor-pointer items-center text-base text-primary border border-solid border-primary" @click="applyAll()">
            <span class="text-base text-primary text-center">Apply All</span>
					</div>
				</div>

				<!-- Variation Summary -->
				<!-- Root Table -->
				<vs-table class="mt-10" v-if="isEnableRoot && !isEnableTree" :data="variation.root">
						<template slot="header">
							<h4>Variation Summary Table</h4>
						</template>
						<template slot="thead">
							<vs-th v-show="isEnableRoot">{{others}}</vs-th>
							<vs-th>Price(RM)</vs-th>
							<vs-th>Stock</vs-th>
							<vs-th>SKU</vs-th>
							<vs-th>Volumetric(KG)
							<vx-tooltip title="Why we need this?"
								text="Volumetric weight is to measure the bulkiness of an item in order to prevents any weightage discrepancy in future that might leads to expensive shipping charges.">
								<feather-icon class="vd-info vx-col cursor-pointer" icon="InfoIcon" svgClasses="h-4 w-4"/>
							</vx-tooltip>
							</vs-th>
							<vs-th>Weight(KG)</vs-th>
						</template>
			
						<template slot-scope="">
							<vs-tr v-for="(option, index) in variation.root" :key="'d'+index">

								<vs-td :data="option.label">
									{{ option.label }}
								</vs-td>
								
								<vs-td :class="hoverPrice ? 'hover_class' : ''" :data="option.price">
									<vs-input 
									class="data-input-table w-full" 
									v-model="option.price"
									:name="option.label+' price'"
									data-vv-validate-on="blur" 
									v-validate="{required: true, regex : '^[+]?([0-9]+([.][0-9]*)?|[.][0-9]+)$'}"/>
									<span class="text-danger text-sm mt-3 vx-col">{{ errors.first(`${option.label+' price'}`) }}</span>
								</vs-td>
								

								<vs-td  :class="hoverStock? 'hover_class' : ''" :data="option.inventory_count">
									<vs-input 
									class="data-input-table w-full" 
									v-model="option.inventory_count"
									:name="option.label+' stock'"
									data-vv-validate-on="blur" 
									v-validate="{required: true, regex : '^[0-9]*$'}" />
									<span class="text-danger text-sm mt-3 vx-col">{{ errors.first(`${option.label+' stock'}`) }}</span>
								</vs-td>

								<vs-td :class="hoverSku ? 'hover_class' : ''" :data="option.sku">
									<vs-input class="data-input-table w-full" v-model="option.sku" />
								</vs-td>

								<vs-td :class="hoverVolumetric ? 'hover_class' : ''" :data="option.volumetric">
									<vs-input 
									class="data-input-table w-full" 
									v-model="option.volumetric"
									:name="option.label+' volumetric'"
									data-vv-validate-on="blur"
									v-validate="{regex : '^[+]?([0-9]+([.][0-9]*)?|[.][0-9]+)$'}"/>
									<span class="text-danger text-sm mt-3 vx-col">{{ errors.first(`${option.label+' volumetric'}`) }}</span>
								</vs-td>

								<vs-td :class="hoverWeight ? 'hover_class' : ''" :data="option.weight">
									<vs-input 
									class="data-input-table w-full" 
									v-model="option.weight"
									:name="option.label+' weight'"
									data-vv-validate-on="blur"
									v-validate="{required: true, regex : '^[+]?([0-9]+([.][0-9]*)?|[.][0-9]+)$'}" />
									<span class="text-danger text-sm mt-3 vx-col">{{ errors.first(`${option.label+' weight'}`) }}</span>
								</vs-td>

							</vs-tr>
						</template>
				</vs-table>

				       
				<!-- Root + Tree -->
			  <vs-table v-if="isEnableRoot && isEnableTree" :data="variation.root">
					<template slot="header">
						<h4>Variation Summary Table</h4>
					</template>
					<template slot="thead">
							<vs-th>{{others}}</vs-th>
							<vs-th>{{others2}}</vs-th>
							<vs-th>Price(RM)</vs-th>
							<vs-th>Stock</vs-th>
							<vs-th>SKU</vs-th>
							<vs-th>Volumetric(KG)
								<vx-tooltip title="Why we need this?"
								text="Volumetric weight is to measure the bulkiness of an item in order to prevents any weightage discrepancy in future that might leads to expensive shipping charges.">
								<feather-icon class="vd-info vx-col cursor-pointer" icon="InfoIcon" svgClasses="h-4 w-4"/>
								</vx-tooltip>
							</vs-th>
							<vs-th>Weight(KG)</vs-th>
					</template>

					<tbody v-for="(root,tindex) in combo" :key="tindex" slot-scope="">
						<vs-tr v-for="(tree, index) in root.tree" :key="index">
							<vs-td v-if="index == 0" :rowspan="root.tree.length" :data="root.label">{{root.label}}</vs-td>
							<vs-td :data="tree.label">{{tree.label}}</vs-td>
							<vs-td :class="hoverPrice ? 'hover_class' : ''" :data="tree.price" >
								<vs-input 
								:name="root.label+' '+tree.label+' price'" 
								data-vv-validate-on="blur" 
								v-validate="{required: true, regex : '^[+]?([0-9]+([.][0-9]*)?|[.][0-9]+)$'}"  
								class="data-input-table w-1/2" v-model="tree.price" />
							  <span class="text-danger text-sm mt-3 vx-col">{{ errors.first(`${root.label+' '+tree.label+' price'}`) }}</span>
							</vs-td>

							<vs-td :class="hoverStock ? 'hover_class' : ''" :data="tree.inventory_count">
								<vs-input 
								:name="root.label+' '+tree.label+' stock'" 
								class="data-input-table w-1/2" 
								data-vv-validate-on="blur" 
								v-validate="{required: true, regex : '^[0-9]*$'}" 
								v-model="tree.inventory_count" />
								<span class="text-danger text-sm mt-3 vx-col">{{ errors.first(`${root.label+' '+tree.label+' stock'}`) }}</span>
							</vs-td>
							

							<vs-td :class="hoverSku ? 'hover_class' : ''" :data="tree.sku">
								<vs-input class="data-input-table w-full" :name="'sku '+index" v-model="tree.sku" />
							</vs-td>

							<vs-td :class="hoverVolumetric ? 'hover_class' : ''" :data="tree.volumetric">
								<vs-input 
								:name="root.label+' '+tree.label+' volumetric'" 
								class="data-input-table w-1/2" 
								data-vv-validate-on="blur" 
								v-validate="{regex : '^[+]?([0-9]+([.][0-9]*)?|[.][0-9]+)$'}" 
								v-model="tree.volumetric" />
								<span class="text-danger text-sm mt-3 vx-col">{{ errors.first(`${root.label+' '+tree.label+' volumetric'}`) }}</span>
							</vs-td>

							<vs-td :class="hoverWeight ? 'hover_class' : ''" :data="tree.weight">
								<vs-input 
								:name="root.label+' '+tree.label+' weight'" 
								class="data-input-table w-1/2" 
								data-vv-validate-on="blur" 
								v-validate="{required: true, regex : '^[0-9]*$'}" 
								v-model="tree.weight" />
								<span class="text-danger text-sm mt-3 vx-col">{{ errors.first(`${root.label+' '+tree.label+' weight'}`) }}</span>
							</vs-td>

						</vs-tr>
					</tbody>
				</vs-table>

				<!-- Price Tier -->
				<!-- <div class="piece-container">
					<div v-show="!isEnablePriceTier" class="p-3 mt-3 text-center align-center font-medium rounded cursor-pointer items-center text-base text-primary border border-solid border-primary" @click="isEnablePriceTier = true">
							<feather-icon icon="PlusCircleIcon" svgClasses="h-4 w-4" />
							<span class="ml-2 mt-1 text-base text-primary">Enable Wholesale Price Tier</span>
					</div>
					<feather-icon v-show="isEnablePriceTier" icon="XIcon" @click.stop="initEnable('priceTier')" class="cross-icon-pieces cursor-pointer"></feather-icon>
          <div v-show="isEnablePriceTier">
             <h5>Pieces</h5>
             <div class="form-group vx-row" v-for="(piece, index) in pieces" :key="index">
               <vs-input 
							 class="vx-col mt-2" 
							 v-model="piece.label" 
							 placeholder="Piece: eg 12" 
							 v-validate="'required|numeric|min_value:2'" 
							 :name="'piece '+index" 
							 data-vv-validate-on="blur" />
							<vx-input-group class="mt-2">
							 <template slot="prepend">
							 	<div class="prepend-text bg-primary">
									<span>RM</span>
								</div>
							 </template>
							 <vs-input 
							 class="vx-col" 
							 v-model="piece.price" 
							 placeholder="Price: eg 39.90" 
							 v-validate="{required: true, regex : '^[+]?([0-9]+([.][0-9]*)?|[.][0-9]+)$'}" 
							 :name="'price '+index" 
							 data-vv-validate-on="blur" />
							</vx-input-group> 
               <feather-icon class="cursor-pointer vx-col" icon="Trash2Icon" svgClasses="h-4 w-4" @click="removePiece(index)" />
							<div class="vx-row">
							 <span class="text-danger text-sm mt-3 vx-col">{{ errors.first(`${'piece '+index}`) }}</span>
							 <span class="text-danger text-sm mt-3 vx-col">{{ errors.first(`${'price '+index}`) }}</span>
							</div>
             </div>
             <div class="p-3 mt-3 ml-5 w-3/4 text-center font-medium rounded cursor-pointer items-center text-base text-primary border border-solid border-primary" @click="addNewPiece">
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
              <span class="ml-2 text-base text-primary">Add Piece</span>
             </div>
           </div>
				</div> -->

			  <!-- Product Image -->
				<div class="img-container">
					<h3>Media Centre</h3>
					<div class="media-section">
						<vs-upload class="upload" 
						text="Upload Cover Photo"
						limit=1
						accept=".png,.jpeg,.jpg"
						name="cover_photo" 
						@change="onSelectedImage" 
						@on-success="successUpload"
						@on-delete="imageDeleted"
						@on-error="uploadError"
						:show-upload-button="false"></vs-upload>
						
						<vs-upload 
						v-for="(file, index) in fileLimit"
						:key="index"
						class="upload"
						:text="'Upload Photo '+(index+2)"
						limit=1
						accept=".png,.jpeg,.jpg"
						:show-upload-button="false" 
						@change="onSelectedImage"     
						@on-success="successUpload" 
						@on-delete="imageDeleted" 
						@on-error="uploadError"></vs-upload>
					</div>
				</div>
					
				<div class="shipping-container">
						<div class="shipping-fee-section">
							<h3 class="shipping-section-header">Sales Information</h3>
							<div class="vx-row mt-5">
								<!-- <div class="vx-col mt-5"> -->
									<label class="vs-input--label">Free Shipping Fee</label>
									<vx-tooltip text="If you toogle this off, we will charge the shipping fee based on the shipping fee setting.">
										<feather-icon class="vx-col cursor-pointer" icon="InfoIcon" svgClasses="h-4 w-4"/>
									</vx-tooltip>
								<!-- </div> -->
							</div>
							<vs-switch icon-pack="feather" vs-icon-off="icon-x" vs-icon-on="icon-check" v-model="is_shipping_free" vs-value=1 style="width: 60px;">
											<span slot="on">Yes</span>
											<span slot="off">No</span>
							</vs-switch>


					<div v-if="variant === false" class="product-price-section mt-5">
						<label class="vs-input--label">Product Price</label>
						<vx-input-group class="w-1/3 mt-3">
							<template slot="prepend">
							<div class="prepend-text bg-primary">
								<span>RM</span>
							</div>
							</template>
							<vs-input 
							class="vx-col" 
							v-model="product_price" 
							v-validate="{required: true, regex : '^[+]?([0-9]+([.][0-9]*)?|[.][0-9]+)$'}" 
							name="product price" 
							data-vv-validate-on="blur"
							ref="product_price" />
						</vx-input-group> 
						<span class="text-danger text-sm mt-3 vx-col">{{ errors.first('product price') }}</span>

						<div class="mt-5">
						<label class="vs-input--label">Stock</label>
							<vs-input-number 
							class="vx-col" 
							style="width:200px;"  
							name="product stock" 
							color="#f9278e" 
							v-validate="{required: true}"
							v-model="product_stock"
							data-vv-validate-on="blur"
							ref="product_stock"/>
						<span class="text-danger text-sm mt-3 vx-col">{{ errors.first('product stock') }}</span>
						</div>
						
						<div class="mt-5">
							<vs-input 
							label="SKU"
							class="vx-col" 
							v-model="product_sku"  
							name="product sku" 
							data-vv-validate-on="blur"
							ref="product_sku" />
						<span class="text-danger text-sm mt-3 vx-col">{{ errors.first('product sku') }}</span>
						</div>

						<div class="weight-section mt-5">
							<vs-input
								label="Weight(KG)"
								class="vx-col" 
								v-model="product_weight" 
								v-validate="{required: true, regex : '^[+]?([0-9]+([.][0-9]*)?|[.][0-9]+)$'}" 
								name="weight" 
								data-vv-validate-on="blur"
								ref="product_weight" />
					    <span class="text-danger text-sm mt-3 vx-col">{{ errors.first('weight') }}</span>
					</div>

					<div class="volumetric-section mt-5">
						<div class="vx-row">
							<label class="vd-label vs-input--label mr-3"> Volumetric Weight (KG)</label>
							<vx-tooltip title="Why we need this?"
							text="Volumetric weight is to measure the bulkiness of an item in order to prevents any weightage discrepancy in future that might leads to expensive shipping charges.">
								<feather-icon class="vd-info vx-col cursor-pointer" icon="InfoIcon" svgClasses="h-4 w-4"/>
							</vx-tooltip>
							</div>
							<vs-input 
							class="vx-col" 
							v-model="product_volumetric" 
							name="volumetric" 
							@click="popupActive=true"
							ref="product_volumetric" />
					    <span class="text-danger text-sm mt-3 vx-col">{{ errors.first('volumetric') }}</span>

							
							<vs-popup classContent="popup-example" title="Volumetric Calculator" :active.sync="popupActive">
							<div class="volumetric-container">
								<div class="volumetric-cal-form">
										<div>
											<label class="vs-input--label">Length (cm)</label>
											<vs-input 
												class="length-text-field vx-col" 
												v-model="length" 
												v-validate="{required: true, regex : '^[+]?([0-9]+([.][0-9]*)?|[.][0-9]+)$'}" 
												name="length" 
												data-vv-validate-on="blur" />
											<span class="text-danger text-sm vx-col">{{ errors.first('length') }}</span>
										</div>
										
										
										<div>
											<label class="vs-input--label">Height (cm)</label>
											<vs-input 
												class="height-text-field vx-col" 
												v-model="height" 
												v-validate="{required: true, regex : '^[+]?([0-9]+([.][0-9]*)?|[.][0-9]+)$'}" 
												name="height" 
												data-vv-validate-on="blur" />
											<span class="text-danger text-sm vx-col">{{ errors.first('height') }}</span>
										</div>

										<div>
											<label class="vs-input--label">Width (cm)</label>
											<vs-input 
												class="width-text-field vx-col" 
												v-model="width" 
												v-validate="{required: true, regex : '^[+]?([0-9]+([.][0-9]*)?|[.][0-9]+)$'}" 
												name="width" 
												data-vv-validate-on="blur"/>
											<span class="text-danger text-sm">{{ errors.first('width') }}</span>
										</div>

										<vs-button class="w-1/2 shadow-md mt-2" :disabled="!validateVolumetricForm" @click="calculateVolumetric(length,height,width,'n')">Calculate</vs-button>
									</div>

									<div class="volumetric-img">
										<img src="@/assets/images/pages/xmas_surprise.svg" />
										<div class="h"><span>H</span></div>
										<div class="w">W</div>
										<div class="l">L</div>
									</div>
							</div>		
							</vs-popup>
					</div>
						  
					</div>
					</div>
				</div>

      </div>
    </component>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button id="add-product-step-2" class="mb-6 mr-6" @click="submitData(1)" >Save and Publish</vs-button>
			<vs-button class="mb-6 mr-6" @click="submitData(0)">Save as Draft</vs-button>
      <vs-button class="mb-6 mr-6" type="border" color="danger" @click="resetPrompt = true">Reset</vs-button>
    </div>

		<vs-prompt
      @cancel="''"
      @accept="initValues"
      @close="''"
      :active.sync="resetPrompt">
      <div class="con-exemple-prompt">
        <span>Are you sure want to reset all fields?</span>
      </div>
    </vs-prompt>
		<v-tour v-if="this.products.length === 0" name="addProductTour" :steps="steps"></v-tour>
		</div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { Validator } from 'vee-validate'
import vSelect from 'vue-select'

const dialogs = {
  expired: (error) => {
    return {
      color: "danger", 
      title: "Package Expired!",
      text: "Opps, looks like your package already expired, kindly subscribe a new one.",
      accept:() => {
        router.push({name: 'billing-current-plan'})
      },
      close:() => {
        router.push({name: 'billing-current-plan'})
      }
    }
	},
	exceeded: (error) => {
		return {
      color: "danger", 
      title: "Product Limit Exceeded.",
      text: "Opps, your product creation has reached the limit.",
      accept:() => {
        router.push({name : 'dashboard'})
      },
      close:() => {
        router.push({name : 'dashboard'})
      }
    }
	}
}

const dict = {
  custom: {
    others: {
      required: 'Please enter the variant name',
    },
    others2: {
      required: 'Please enter the variant name',
      is_not: "Variant name cannot be the same"
		},
		
  }
}

// register custom messages
Validator.localize('en', dict);

export default {
  components: {
		VuePerfectScrollbar,    
		'v-select': vSelect

  },
  data () {
    return {
      name: '',
      description: '',
      category: null,
      counterDanger: false,
			is_shipping_free: true,
			shipping_fee: '',
      condition: true,
			variant: false,
			popupActive: false,
			product_sku: '',
			product_stock: 0,
			product_price: '',
			product_weight: '',
			product_volumetric: '',
			length: '',
			height: '',
			width: '',
			allPrice: '',
			allStock: '',
			allSku: '',
			allVolumetric:'',
			allWeight: '',
			others: '',
			others2: '',
			image: null,
			images: [],
			isEnableRoot: false,
			isEnableTree: false,
			// isEnablePriceTier: false,
			hoverPrice: false,
			hoverStock: false,
			hoverSku: false,
			hoverVolumetric: false,
			hoverWeight: false,
			resetPrompt: false,
			popupActive_all: false,
			// pieces: [],
			variation: {
				root: [],
				tree: []
			},
			combo: {},
			fileLimit: 7,
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
			},
			steps: [
				{
          target: '#add-product-step-1', 
          header: {
            title: 'Adding a Product',
          },
          content: `We have prepared sample product information for you. Just click on ‘next’ to continue.`,
        },
        {
          target: '#add-product-step-2', 
          header: {
            title: ' Save and Publish This Product',
          },
          content: `Let’s click on the button to publish this sample product!`,
        },
			]
    }
	},
	async created() {
    await this.$store.dispatch('product/getCategories');
		this.categories = this.$store.state.product.categories;
		
		if(this.$store.state.user.organizations.find(o => o.organization_id === this.$store.state.organization.current_organization[0].id)  !== null){
			let current_package_limit = this.$store.state.user.organizations.find(o => o.organization_id === this.$store.state.organization.current_organization[0].id)
			this.$store.dispatch('subscription/getSubscriptionSummary').then(() => {
				if(!((this.$store.state.subscription.subscription_summary.total_product_quota - this.$store.state.subscription.subscription_summary.total_product_created) > 0)){
					this.$vs.dialog(dialogs.exceeded())
				}
			})
		}else{
			this.$vs.dialog(dialogs.expired())
		}
  },
  watch: {
		variation : {
			handler(newCombo) {
				this.combo = this.onSync(newCombo)
			},
			deep: true,
			immediate: true,
		}
	},
  computed: {
		getCategory() {
			return this.$store.state.product.categories
		},
    isFormValid () {
			return !this.errors.any() && this.name !=='' && this.description !== '' && this.category !== null && this.counterDanger === false 
			&& this.check === true
		},
		check () {
			if(this.isEnableRoot === false && this.isEnableTree === false){
				if(this.product_price == '' || this.product_stock == '' || this.product_stock === 0 || this.product_weight === 0
				|| this.product_weight === ''){
					return false
				} else {
					return true
				} 
			} else {
				return true
			}
		},
		validateVolumetricForm () {
			return this.width !== '' && this.length !== '' && this.height !== ''
		},
		scrollbarTag () { return this.$store.getters.scrollbarTag },
		products(){
			return this.$store.dispatch('product/getProducts')
		}
	},
	mounted (){
		if(this.products.length === 0){
			this.$tours['addProductTour'].start()
		}
	},
  methods: {
		onSelectedImage () {
			this.image = event.target.files[0]
			const reader = new FileReader()
			reader.readAsDataURL(this.image)
				reader.onload = e => {
					const img_element = document.createElement("img")
					img_element.src = e.target.result
					img_element.onload = event => {
						let canvas = document.createElement("canvas"),MAX_WIDTH = 500
						let scaleSize = MAX_WIDTH / event.target.width
						canvas.width = MAX_WIDTH
						canvas.height = event.target.height * scaleSize

						const ctx = canvas.getContext("2d")
						ctx.drawImage(event.target,0,0,canvas.width,canvas.height)

						const srcEncoded = ctx.canvas.toDataURL(event.target,"image/png")
						this.images.push(this.b64toBlob(srcEncoded))
					}	
				}
		},
		b64toBlob(dataURI){
			let byteString = atob(dataURI.split(',')[1])
			let ab = new ArrayBuffer(byteString.length)
			let ia = new Uint8Array(ab)

			for (let i = 0; i < byteString.length; i++) {
				ia[i] = byteString.charCodeAt(i)
			}
			return new Blob([ab], { type: 'image/png' })
		},
		addRootVariant () {
			this.variation.root.push({
			label: '',
			price: '',
			inventory_count: 0,
			sku: '',
			volumetric: '',
			weight: ''
			})

			if(this.variation.tree.length !== 0){
				for(let i= 0; i < this.variation.root.length; i ++){
					Object.assign(this.variation.root[i], {tree : this.variation.tree})
				}
			}
		},
		removeRoot(index) {
			this.variation.root.splice(index, 1)
		},
		addTreeVariant () {
			this.variation.tree.push({
			label: '',
			price: '',
			inventory_count: 0,
			sku: '',
			volumetric: '',
			weight: ''
			})

			if(this.variation.root.length !== 0){
				for(let i= 0; i < this.variation.root.length; i ++){
					Object.assign(this.variation.root[i], {tree : this.variation.tree})
				  //console.log(JSON.stringify(this.variation.root[i].tree))
				}
			}
			//console.log(JSON.stringify(this.variation))
		},
		removeTree(index) {
			this.variation.tree.splice(index, 1)
			
			if(this.variation.tree.length === 0) {
				for (let i = 0; i < this.variation.root.length; i++) {
					delete this.variation.root[i]['tree']
				}
			}
			// console.log(JSON.stringify(this.variation.root))
		},
		applyAll() {
			//Root variant
			if(this.variation.root.length > 0 && this.variation.tree.length === 0) {
				for(let i = 0; i < this.variation.root.length; i++){
					this.variation.root[i].price = this.allPrice == '' ? '' : parseFloat(this.allPrice)
					this.variation.root[i].inventory_count = this.allStock == '' ? '' : parseInt(this.allStock)
					this.variation.root[i].sku = this.allSku
					this.variation.root[i].volumetric = this.allVolumetric == '' ? '' : parseFloat(this.allVolumetric)
					this.variation.root[i].weight = this.allWeight == '' ? '' : parseFloat(this.allWeight)
				}
			// Have two variants 
			} else if (this.variation.root.length > 0 && this.variation.tree.length > 0) {
					for(let i = 0; i < this.variation.root.length; i ++){
						for(let j = 0; j < this.variation.tree.length; j++) {
							this.variation.root[i].tree[j].price = this.allPrice == '' ? '' : parseFloat(this.allPrice)
							this.variation.root[i].tree[j].inventory_count = this.allStock == '' ? '' : parseInt(this.allStock)
							this.variation.root[i].tree[j].sku = this.allSku
							this.variation.root[i].tree[j].volumetric = this.allVolumetric == '' ? '' : parseFloat(this.allVolumetric)
							this.variation.root[i].tree[j].weight = this.allWeight == '' ? '' : parseFloat(this.allWeight)
						}
					}
			}
		},
		calculateVolumetric (length,height,width,type) {
			const vol_divider = 5000,min_volumetric = 0.1,calculated = 0

			calculated = +((length*height*width) / vol_divider).toFixed(2)

			if(calculated < min_volumetric){
				calculated = min_volumetric
			}

			if(type === 'a') {
				this.allVolumetric = calculated
				this.popupActive_all = false
			}else {
				this.product_volumetric = calculated
				this.popupActive = false
			}		
		},
		onSync (newCombo) {
			if (!newCombo.root || newCombo.root.length === 0 || !newCombo.tree || newCombo.tree.length === 0) return 
		
			this.combo =  JSON.parse(JSON.stringify(newCombo.root))
			// console.log(JSON.stringify(this.combo))
			return this.combo
		},
		initOptions () {
			if(this.variant === false) {
				this.isEnableRoot = false
				this.isEnableTree = false
				// this.isEnablePriceTier = false
				this.variation.root = []
				this.variation.tree = []
				// this.pieces = []

				this.allPrice = ''
				this.allStock = ''
				this.allSku = ''
				this.$nextTick(() => {
    			this.errors.clear()
				}) 
			}
		},
		initEnable(value) {
			switch (value){
				case 'root':
					this.others = ''
					this.variation.root = []
					if(this.variation.root.length === 0 && this.variation.tree.length > 0){
						this.variation.root = this.variation.tree
						this.others = this.others2
						this.others2 = ''
						this.variation.tree = []
						this.isEnableTree = false
						this.$nextTick(() => {
    					this.errors.clear()
						})  
					} else {
						this.isEnableRoot = false
						this.$nextTick(() => {
    					this.errors.clear()
						})  
					}
					break;
				case 'tree':
					this.isEnableTree = false
					this.others2 = ''
					this.variation.tree = []
					break
				// case 'priceTier':
				// 	this.isEnablePriceTier = false
				// 	this.pieces = []
				// 	break
			}
		},
		// addNewPiece () {
		// 	this.pieces.push({
		// 	label: '',
		// 	price: '',
		// 	inventory_count: '',
		// 	sku: '',
		// 	volumetric: '',
		// 	weight: ''
		// 	})
		// },
		// removePiece (index) {
		// 	this.pieces.splice(index, 1)
    // },
    initValues () {
			this.name = '',
			this.description = ''
			this.category = null,
			this.condition = true,
			this.is_shipping_free = true,
			this.variant = false,
			this.weight = ''
			this.volumetric = ''
			this.product_price = ''
			this.product_stock = 0
			this.product_sku = ''
			this.initOptions() 
    },
    submitData (status) {
			if(this.isFormValid === false){
				this.$refs[this.errors.items[0].field].$el.querySelector('[name=' + this.errors.items[0].field + ']').focus()
			}else{
			this.$vs.loading()
					//start reconstructing payload
					let recon_var = []

					//no variant 
					if(this.variation.root.length === 0 && this.variation.tree.length === 0){
						recon_var.push({
							price: parseFloat(this.product_price),
							inventory_count: this.product_stock,
							sku: this.product_sku,
							volumetric: this.product_volumetric,
							weight: parseFloat(this.product_weight),
							option: []
							})
							// if(this.pieces.length > 0) {
							// 	this.pieces.forEach(piece => {
							// 		recon_var.push({
							// 		price: parseFloat(piece.price),
							// 		inventory_count: this.product_stock,
							// 		sku: this.product_sku,
							// 		volumetric: this.volumetric,
							// 		weight: parseFloat(this.weight),
							// 		option: [{
							// 			option: 3,
							// 			label: 'piece',
							// 			value: piece.label
							// 			}]
							// 		})
							// 	})
							// }
					//just root variant
					} else if(this.variation.root.length > 0 && this.variation.tree.length === 0){
						for(let i = 0; i < this.variation.root.length; i++){
							let option = {
									option: 4, 
									label: this.others, 
									value: this.variation.root[i].label
									}
							recon_var.push({
								price: parseFloat(this.variation.root[i].price),
								inventory_count: this.variation.root[i].inventory_count,
								sku: this.variation.root[i].sku,
								volumetric: this.variation.root[i].volumetric,
								weight: parseFloat(this.variation.root[i].weight),
								option: [option]
								})
							// if(this.pieces.length > 0) {
							// 	this.pieces.forEach(piece => {
							// 		recon_var.push({
							// 		price: parseFloat(piece.price),
							// 		inventory_count: Math.round(this.variation.root[i].inventory_count / piece.label),
							// 		sku: this.variation.root[i].sku,
							// 		volumetric: this.volumetric * piece.label,
							// 		weight: parseFloat(this.weight)* piece.label,
							// 		option: [option,{
							// 			option: 3,
							// 			label: 'piece',
							// 			value: piece.label
							// 			}]
							// 		})
							// 	})
							// }
						}
					// root + tree variant
					} else if(this.combo.length > 0) {
						for(let i = 0; i < this.combo.length; i++){
							let root_option = {
									option: 4, 
									label: this.others, 
									value: this.combo[i].label
									}
							for(let j = 0; j < this.combo[i].tree.length; j++){
								let tree_option = {
										option: 4,
										label: this.others2,
										value: this.combo[i].tree[j].label
									}
								recon_var.push({
									price: parseFloat(this.combo[i].tree[j].price),
									inventory_count: this.combo[i].tree[j].inventory_count,
									sku: this.combo[i].tree[j].sku,
									volumetric: this.combo[i].tree[j].volumetric,
									weight: this.combo[i].tree[j].weight,
									option: [root_option,tree_option]
								})
								// if(this.pieces.length > 0) {
								// 	this.pieces.forEach(piece => {
								// 		recon_var.push({
								// 			price: parseFloat(piece.price),
								// 			inventory_count: Math.round(this.combo[i].tree[j].inventory_count / piece.label),
								// 			sku: this.combo[i].tree[j].sku,
								// 			volumetric: this.volumetric * piece.label,
								// 			weight: this.weight * piece.label,
								// 			option: [root_option, tree_option, {
								// 				option: 3,
								// 				label: 'piece',
								// 				value: piece.label
								// 			}]
								// 		})
								// 	})
								// }
							}
						}
					}
          let payload = {
						product: {
							organization_id: this.$store.state.organization.current_organization[0].id,
							added_by: this.$store.state.user.id,
							name: this.name,
							description: this.description,
							category_id: this.category.id,
							is_shipping_free: this.is_shipping_free ? 1 : 0,
							condition: this.condition ? 1 : 0,
							status: status,
							image: null
						},
							variation : recon_var
					}
					console.log(JSON.stringify(payload))
					// console.log(this.images)

					// console.log(this.images)
					this.$store.dispatch('product/createProduct', payload)
						.then(() => {
							if(this.images.length > 0) {
								this.$store.dispatch('product/updateImage', this.images)
								.then(() => {
									this.$vs.loading.close()
									this.$vs.notify({
										title: 'Success',
										text: 'Product Added Successful!',
										iconPack: 'feather',
										icon: 'icon-check',
										color: 'success'		
									})
									setTimeout(()=> {
       					 		location.reload()
      						}, 2000)
								})
								.catch((err) => {console.log(err)})
							} else {
								this.$vs.loading.close()
								this.$vs.notify({
									title: 'Success',
									text: 'Product Added Successful!',
									iconPack: 'feather',
									icon: 'icon-check',
									color: 'success'		
								})
								setTimeout(()=> {
       					 		location.reload()
      					}, 2000)	
							}
						})
						.catch(()=> {
							this.$vs.notify({
							title: 'Oppsy',
							text: 'Product Added Failed!',
							iconPack: 'feather',
							icon: 'icon-alert-circle',
							color: 'danger'
						})
				})
			}	
		},
		successUpload(event){	
		this.$vs.notify({color:'success',title:'Upload Success',text:'Hooray! Your product easily to see by your customer.'})
		},
		imageDeleted(event) {
			this.images.splice(this.images.indexOf(event),1)
			this.$vs.notify({color:'success',title:'Image Removed',text:'Your image has been removed.'})
		},
		uploadError(event) {
			this.$vs.notify({color:'danger',title:'Error Occured',text:'Upload Error'})
		},
		setFocusOnInput(inputName) {
			let inputEl = this.$refs[inputName].$el.querySelector('input')
			inputEl.scrollIntoView(false)
		}
	}
}
</script>

<style lang="scss">
  .v-tour {
    .v-step {
        z-index: 52000;
        background-color: rgba(var(--vs-primary),1);
        border-radius: .5rem;
        padding: 1.5rem;
        filter: drop-shadow(0 0 7px rgba(0,0,0,.5));

        .v-step__arrow {
            border-color: rgba(var(--vs-primary),1);
        }

        .vs-button-border:not(.btn-tour-next):not(.btn-tour-finish) {
            border-color: rgba(255, 255, 255, .5) !important;
        }

        .v-step__header{
          background-color: #CE0668;
        }
    }
	}
	
.hover_class{
 background: #FEEDF6;
}
vs-table {
	text-align: center;
}
.vs-table--tbody-table .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
	background: #FEEDF6;
}
.cross-icon {
   position:absolute;
   top:0;
	 left:200px;
}
.cross-icon-pieces{
   position:absolute;
   top:0;
	 left:450px;
}
.variant-container {
  background-color: #fff;
	border-radius: 10px;
	padding: 15px 25px;
	position: relative;
	width: 30%;
	z-index: 10;
	margin-top: 30px;
	margin-bottom: 30px;
}

.piece-container {
  background-color: #fff;
	border-radius: 10px;
	padding: 15px 25px;
	position: relative;
	width: 55%;
	z-index: 10;
	margin-top: 30px;
	margin-bottom: 30px;
}

.apply-all-container {
	display: grid;
	grid-template-rows: repeat(3,1fr);
	background-color: #fff;
	border-radius: 10px;
	padding: 15px 25px;
	position: relative;
	width: 100%;
	z-index: 10;
	margin-top: 30px;
	margin-bottom: 30px;
}

.apply-all-info {
	align-self: center;
	animation: shine 1s ease infinite;
	span{
		transform: translateY(4px);
	}
}

@keyframes shine {
	from {
		color: #626262;
	}
	to {
		color: #F9278E;
	}
}

.apply-all-form {
	display: flex;
	grid-row: 2 / 3;
	grid-gap: .5rem;
}

.apply-all-button {
	grid-row: 3/4;
	align-self: center;
	justify-self: center;
}


.volumetric-section > label {
	margin-top: 5px;
}

.volumetric-container{
	display: grid;
	grid-template-columns: repeat(2,1fr);
}

.volumetric-cal-form {
	grid-column: 1/2;
}

.volumetric-img {
	grid-column: 2/3;

	img {
		width: 200px;
	}
}

.vd-label {
	transform: translateX(15px);
}

.vd-info {
	transform: translateX(5px);
}

.h{
	display: flex;
  align-items: center;
  text-align: center;
	transform: rotate(-90deg) translateY(-55px) translateX(105px);
	width: 86px;
	color: #F9278E;

	span {
		transform: rotate(90deg);
	}
}

.h:before,.h:after {
		content: '';
    flex: 1;
    border-bottom: 1px solid #F9278E;
}

.h:before{
	margin-right: .25em;
}

.h:after {
	margin-left: .25em;
}

.w {
	display: flex;
  align-items: center;
  text-align: center;
	transform: skewY(35deg) translateY(-45px);
	width: 55px;
	color: #F9278E;
	font-size: 0.8rem;
}

.w:before,.w:after {
		content: '';
    flex: 1;
    border-bottom: 1px solid #F9278E;
}

.w:before{
	margin-right: .25em;
}

.w:after {
	margin-left: .25em;
}

.l {
	display: flex;
  align-items: center;
  text-align: center;
	transform: skewY(-10deg) translateY(-40px) translateX(80px);
	width: 120px;
	color: #F9278E;
}

.l:before,.l:after {
		content: '';
    flex: 1;
    border-bottom: 1px solid #F9278E;
}

.l:before{
	margin-right: .25em;
}

.l:after {
	margin-left: .25em;
}

.img-container {
	background-color: #fff;
	border-radius: 10px;
	padding: 15px 25px;
	position: relative;
	width: 100%;
	z-index: 10;
	margin-top: 30px;
	margin-bottom: 30px;
}
.media-section {
	display: flex;
	flex-wrap: wrap;
	.upload {
		flex: 0 0 21%;	
	}
}

.shipping-container {
    display: grid;
}
.shipping-fee-section {
	  background-color: #fff;
    border-radius: 10px;
    padding: 15px 25px;
    position: relative;
    width: 100%;
    z-index: 10;
    margin-top: 30px;
    margin-bottom: 30px;
		grid-template-rows: repeat(4,1fr);
		grid-template-areas: 
		"shipping-section-header
		 shipping-fee-section ";
}

.shipping-section-header {
	grid-area: shipping-section-header;
}

.data-input-table {
	outline: none !important; 
	border-style: none !important;
}


.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    // height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

    &:not(.ps) {
      overflow-y: auto;
    }
}

@media screen and (max-width: 900px) {
	.variant-container{
		width: 80%;
	}

	.apply-all-container{
		display: flex;
		flex-wrap: wrap;
	}

	.apply-all-form{
		flex-wrap: wrap;
	}

	.apply-all-button{
		margin-top: 10px;
	}

	.volumetric-img{
		display: none;
	}

}
</style>
